import { type TenantLanguage } from '../../../tenant/tenantLanguagesConfig'
import { TENANT } from '../../../tenant/tenantTypes'

export const EXPERIMENT_CROSSELL_LAYOUT_POPUP_SHOW_TIMEOUT = 150_000
export const EXPERIMENT_CROSSELL_LAYOUT_PRODUCTS_COUNT_V1 = 4
export const EXPERIMENT_CROSSELL_LAYOUT_PRODUCTS_COUNT_V2 = 5

/* eslint-disable @typescript-eslint/no-magic-numbers -- crosssell widget ids no constants needed */
const getWidgetId = (tenant: TENANT): number | null => {
  switch (tenant) {
    case TENANT.AT: {
      return 401
    }
    case TENANT.BE: {
      return 526
    }
    case TENANT.CH: {
      return 535
    }
    case TENANT.COM: {
      return 329
    }
    case TENANT.FR: {
      return 475
    }
    case TENANT.IT: {
      return 573
    }
    default: {
      return null
    }
  }
}
/* eslint-enable @typescript-eslint/no-magic-numbers */

type ExperimentCrosssellLayoutWidgetConfig = {
  buttonText: Record<TenantLanguage, string>
  title: Record<TenantLanguage, Record<string, string>>
  widgetId: number | null
}

export const useExperimentCrosssellLayoutConfig = (
  tenant: TENANT,
): ExperimentCrosssellLayoutWidgetConfig => {
  const title = {
    de: {
      subtitle: 'Ihre persönlichen Empfehlungen:',
      title: 'Lassen Sie sich von uns inspirieren!',
    },
    fr: {
      subtitle: 'Nos recommandations personnalisées:',
      title: 'Laissez-vous inspirer!',
    },
    it: {
      subtitle: 'I tuoi consigli personali:',
      title: 'Lasciati ispirare da noi!',
    },
    nl: {
      subtitle: 'Onze aanbevelingen op maat:',
      title: 'Laat je inspireren!',
    },
  }

  const buttonText = {
    de: 'Schließen und zurückgehen',
    fr: 'Fermer et revenir',
    it: 'Chiudi e torna indietro',
    nl: 'Sluit en ga terug',
  }

  return {
    buttonText,
    title,
    widgetId: getWidgetId(tenant),
  }
}
